// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorHolder_FmGXR {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: flex-end; */
  flex-grow: 1;
}

.editorHolder_FmGXR > * {
  pointer-events: none;
}

.editorHolderDetail_H3nUV {
  justify-content: flex-end;
}

/* style={{
  height : '100%',
  width : '100%',
  display : 'flex',
  alignItems : 'center',
  justifyContent : usage === 'detail' ? 'flex-end' : undefined
}} */`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/attribute/editor/PopupEditorWrapper.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;IAMI","sourcesContent":[".editorHolder {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  /* justify-content: flex-end; */\n  flex-grow: 1;\n}\n\n.editorHolder > * {\n  pointer-events: none;\n}\n\n.editorHolderDetail {\n  justify-content: flex-end;\n}\n\n/* style={{\n  height : '100%',\n  width : '100%',\n  display : 'flex',\n  alignItems : 'center',\n  justifyContent : usage === 'detail' ? 'flex-end' : undefined\n}} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorHolder": `editorHolder_FmGXR`,
	"editorHolderDetail": `editorHolderDetail_H3nUV`
};
export default ___CSS_LOADER_EXPORT___;
